var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStartRecordingAudio = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 15,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F65843",
  d: "M6 9.474a2.353 2.353 0 0 0 2.35-2.369l.007-4.737A2.36 2.36 0 0 0 6 0a2.36 2.36 0 0 0-2.357 2.368v4.737A2.36 2.36 0 0 0 6 9.474m4.164-2.369c0 2.369-1.995 4.027-4.164 4.027S1.836 9.474 1.836 7.105H.5c0 2.7 2.137 4.919 4.714 5.306V15h1.572v-2.59c2.577-.378 4.714-2.605 4.714-5.305z"
})));
export default SvgStartRecordingAudio;